import React from "react";

export default class CTAButton extends React.Component {
  render() {
    let { label, disabled, type, ...rest } = this.props;

    return (
      <button
        disabled={disabled}
        type="button"
        className={type !== "secondary" ? "button-cta" : "button-secondary"}
        onClick={this.props.onClick}
        {...rest}
      >
        {label}
      </button>
    );
  }
}

CTAButton.defaultProps = {
  label: "",
  style: {},
  disabled: false,
  onClick: () => {},
};
